module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stan Nicholls\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Stan Nicholls is best known for the internationally acclaimed Orcs: First Blood series. His journalism has appeared in "), _c('I', [_vm._v("Locus, SFX,")]), _vm._v(" the "), _c('I', [_vm._v("Guardian")]), _vm._v(", the "), _c('I', [_vm._v("Independent")]), _vm._v(", the "), _c('I', [_vm._v("Daily Mirror")]), _vm._v(", "), _c('I', [_vm._v("Time Out")]), _vm._v(", "), _c('I', [_vm._v("Sight and Sound")]), _vm._v(", and "), _c('I', [_vm._v("Rolling Stone")]), _vm._v(", among many other publications. He currently lives in the West Midlands, U.K., with his wife, the writer Anne Gay.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jGlErl/tc-custom/9780061847776.jpg?1724861498930",
      "alt": "This image is the cover for the book Diamond Isle, The Dreamtime Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Diamond Isle, The Dreamtime Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Immortality has been Reeth Caldason's curse, for it comes with tormenting visions and a savage rage. In hope of a cure, he has traded his fighting skills for potential access to powerful ancient magic—a desperate gamble that leaves him trapped on the Diamond Isle, at the mercy of the bloodthirsty pirates who plague the surrounding waters. Yet only here can Reeth discover the path that will lead him to an understanding of his true nature . . . if he can survive the devastation to come. For the specter of war looms large, one that threatens to alter or destroy the world he knows.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0